module.exports = __webpack_public_path__ + "img/play-circle.a47c56ff.svg";